import { router } from 'expo-router';
import * as React from 'react';
import { useCallback } from 'react';

import { MarketingCarouselItem } from '@fhs-legacy/universal-components';
import Picture from 'components/picture';
import { NotificationDetails } from 'state/loyalty/hooks/types';

import { DescriptionTextBlock } from './loyalty-notification-card.styled';

const LoyaltyNotificationCard = React.memo<{
  notification: NotificationDetails;
}>(({ notification: { title, image, description, path } }) => {
  const mainImage = image?.locale;
  const titleText = title?.locale;
  const descriptionContent = description?.localeRaw;

  const onClickHandler = useCallback(() => {
    const fullPath = path?.locale || '/';

    router.navigate(fullPath);
  }, [path]);

  if (!mainImage || !titleText || !descriptionContent) {
    return null;
  }

  return (
    <MarketingCarouselItem
      header={titleText}
      image={
        image && <Picture image={mainImage} alt={titleText} borderTopRadius="xl" width="253px" />
      }
      content={<DescriptionTextBlock width="180px" content={descriptionContent} />}
      onPress={onClickHandler}
    />
  );
});

export default LoyaltyNotificationCard;
